import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { searchNext } from '../../state/actions';
import { StateType } from '../../../state/state.types';

const mapState = ({ results, queryParams }: StateType) => ({
  hits: results.hits,
  ended: results.theEnd,
  type: queryParams.type,
  isSearchLoading: results.searchLoading,
  isPaginationLoading: results.paginationLoading,
  originalQueryKey: queryParams.originalQueryKey,
});

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  needMoreHits() {
    dispatch(searchNext());
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
